// extracted by mini-css-extract-plugin
module.exports = {"spaceWrapper":"AthleteSalesReportTable_spaceWrapper__3Nc2y"};